import { render, staticRenderFns } from "./LaboratorioTabela.vue?vue&type=template&id=9568f24e"
import script from "./LaboratorioTabela.vue?vue&type=script&lang=js"
export * from "./LaboratorioTabela.vue?vue&type=script&lang=js"
import style0 from "./LaboratorioTabela.vue?vue&type=style&index=0&id=9568f24e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports